import { DashboardWidgetType } from 'features/dashboard/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { WidgetSettingComposingStrategy } from './widgetSettingComposingStrategy'

const canBeDrilledDown = (widgetSetting: DashboardWidgetType) =>
  widgetSetting.includedUserTags === undefined ||
  widgetSetting.includedUserTags === null ||
  widgetSetting.includedUserTags.length === 0

const isOverMaxInput = () => false

const composeDrillDownWidgetSetting = (
  widgetSetting: DashboardWidgetType,
  insights: InsightData[]
) => ({
  ...widgetSetting,
  includedUserTags: [insights.map((insight) => insight.searchName)]
})

const generateIncludedUserTagsStrategy = (): WidgetSettingComposingStrategy => ({
  canBeDrilledDown,
  isOverMaxInput,
  composeDrillDownWidgetSetting
})

export default generateIncludedUserTagsStrategy
